// 8.3.8 Interview Practice UI (merged as `iv`).
const iv = {
 "scriptLatin": "Latin",
 "scriptCyrillic": "Cyrillique",
 "tabNew": "Nouveau chat",
 "tabChats": "Chats",
 "tabInterview": "Entretien",
 "cardTitle": "Entraînement aux entretiens",
 "cardSub": "Entraîne-toi à une conversation importante avant le jour J.",
 "promise": "Entraîne-toi aux conversations qui comptent avant qu'elles arrivent.",
 "support": "Choisis un entretien ou décris le tien. Ton interlocuteur s'adapte à ton niveau et à tes réponses.",
 "fam": {
  "work": "Travail",
  "education": "Études",
  "travel": "Voyage et démarches",
  "public": "Professionnel",
  "personal": "Personnel",
  "custom": "Personnalisé"
 },
 "sc": {
  "job": "Entretien d'embauche",
  "internship": "Entretien de stage",
  "promotion": "Entretien de promotion",
  "freelance": "Présentation à un client (freelance)",
  "networking": "Réseautage",
  "university": "Admission à l'université",
  "scholarship": "Entretien de bourse",
  "oral_exam": "Oral scolaire",
  "language_exam": "Oral de langue",
  "visa": "Entretien type visa",
  "travel_questions": "Questions en voyage",
  "hotel_problem": "Problème à l'hôtel/en voyage",
  "media": "Interview média/podcast",
  "presentation_qa": "Questions après une présentation",
  "client_meeting": "Rendez-vous client",
  "pro_intro": "Présentation professionnelle",
  "housing": "Logement",
  "doctor": "Rendez-vous chez le médecin",
  "meet_new": "Rencontrer quelqu'un",
  "difficult": "Conversation difficile",
  "custom": "Décris le tien"
 },
 "contextLabel": "Que doit savoir ton interlocuteur ?",
 "contextPh": "Facultatif : poste, entreprise, matière, ce qui t'inquiète…",
 "customPh": "Décris ton entretien, ex. « Demain j'ai un entretien de réceptionniste d'hôtel à Madrid. »",
 "length": "Durée",
 "quick": "Rapide — environ 5 questions",
 "standard": "Standard — environ 10 questions",
 "deep": "Approfondi — environ 15 questions",
 "style": "Style d'entraînement",
 "supportive": "Bienveillant",
 "realistic": "Réaliste",
 "challenging": "Exigeant",
 "start": "Commencer l'entretien",
 "starting": "Préparation de ton interlocuteur…",
 "progress": "{n} sur {total}",
 "answerPh": "Ta réponse…",
 "send": "Envoyer",
 "type": "Écrire",
 "speak": "Parler",
 "listen": "Écouter",
 "help": "Aide-moi à le dire",
 "helpPh": "Écris ce que tu veux dire, dans n'importe quelle langue",
 "helpGo": "Montrer",
 "helpNote": "Sers-t'en comme modèle, puis écris ta propre réponse.",
 "finished": "Merci, l'entretien est terminé. Voyons comment ça s'est passé.",
 "seeReport": "Voir mon bilan",
 "building": "Préparation de ton bilan…",
 "overall": "Bilan",
 "areasT": "Axes de progrès",
 "areas": {
  "clarity": "Clarté",
  "vocabulary": "Vocabulaire",
  "grammar": "Grammaire",
  "naturalness": "Naturel",
  "effectiveness": "Efficacité en entretien"
 },
 "lv": {
  "strong": "Solide",
  "developing": "En progrès",
  "needs_practice": "À travailler"
 },
 "worked": "Ce qui a marché",
 "improve": "À améliorer",
 "better": "Mieux le dire",
 "phrases": "Expressions utiles",
 "save": "Enregistrer",
 "saved": "Enregistré dans Vocab",
 "history": "Tes entretiens",
 "empty": "Aucun entretien pour l'instant.",
 "resume": "Reprendre",
 "startOver": "Recommencer",
 "view": "Voir",
 "st": {
  "active": "En cours",
  "answered": "Prêt pour le bilan",
  "completed": "Terminé"
 },
 "retry": "Un problème est survenu. Tes réponses sont conservées, réessaie.",
 "retryBtn": "Réessayer",
 "newInterview": "Nouvel entretien",
 "back": "Retour",
 "suggest": "Une conversation importante approche ?",
 "suggestBtn": "Essaie l'entraînement aux entretiens",
 "dismiss": "Ignorer",
 "recording": "Enregistrement… touche pour arrêter",
 "transcribing": "Transcription…",
 "micFail": "La voix ne fonctionne pas, écris ta réponse.",
 "disclaimer": "Entraînement linguistique uniquement : pas de conseil juridique, migratoire, médical ou de recrutement.",
 "describeFirst": "Décris d'abord ton entretien."
};
export default iv;
